<template>

  <div data-bind="with: invoice">

    <h3 data-bind="text: title"></h3>

    <table class="table table-striped invoice-table">
      <thead>
      <tr>
        <th>Beschrijving</th>
        <th>Aantal</th>
        <th>Stukprijs</th>
        <th>BTW</th>
        <th>Totaal</th>
      </tr>
      </thead>

      <tbody v-for="(line, i) in groupedLines" :key="`l_${i}`">
        <b-tr>
          <b-td colspan="5" class="font-weight-bold">{{line.section.title}}</b-td>
        </b-tr>
        <b-tr v-for="(line_item, j) in line.line_items" :key="`i_${j}`">
          <td>
            {{line_item.description}}<br />
            <div v-html="line_item.extended_description" class="ml-2 text-muted" />
          </td>
          <td>{{line_item.quantity}}</td>
          <td>{{line_item.unit_price.amount|format_money}}</td>
          <td></td>
          <td>{{ (line_item.quantity * line_item.unit_price.amount)|format_money}}</td>
        </b-tr>
      </tbody>
      <tfoot>
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>{{total|format_money}}</td>
      </tr>
      </tfoot>
<!--
      <tbody data-bind="foreach: lines">
      <tr data-bind="visible: subtitle" style="font-weight: bold">
        <td data-bind="text: subtitle" colspan="5"></td>
      </tr>
      <tr>
        <td><span data-bind="text: description"></span><p data-bind="html: custom_descr" style="margin-left: 1em"></p></td>
        <td data-bind="text: amount"></td>
        <td>€ <span data-bind="text: price.toFixed(4)"></span></td>
        <td></td>
        <td>€ <span data-bind="text: (price * amount).toFixed(4)"></span></td>
      </tr>
      </tbody>

      <tfoot>
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>€ <span data-bind="text: total.toFixed(4)"></span></td>
      </tr>
      </tfoot>-->
    </table>

  </div>


</template>

<script>

export default
{
    computed:
    {
        total()
        {
            return this.groupedLines.reduce(
                (total, groupedLine) =>
                {
                    return total + groupedLine.line_items.reduce(
                            (acc, line_item) =>
                               acc + (line_item.quantity * line_item.unit_price.amount),
                            0
                        );
                },
                0
            );
        }
    },
    props:
    {
        groupedLines: { type: Array }
    }
}
</script>

<style>

table.invoice-table thead tr
{
    background-color: #000;
    color: white;
}

table.invoice-table tbody tr td:nth-child(2),
table.invoice-table tbody tr td:nth-child(3),
table.invoice-table tbody tr td:nth-child(4),
table.invoice-table tbody tr td:nth-child(5),
table.invoice-table tfoot tr td
{
    text-align: right;
    font-family: Consolas, monospace;
    white-space: nowrap;
}


</style>